import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
    <path
      fillRule="evenodd"
      d="M12 4.25c-7.232 0-10.522 6.075-11.085 7.23-.16.33-.16.71 0 1.04.563 1.155 3.853 7.23 11.085 7.23s10.522-6.075 11.085-7.23c.16-.33.16-.71 0-1.04-.563-1.155-3.853-7.23-11.085-7.23m0 14c-6.054 0-8.985-4.912-9.668-6.25.683-1.338 3.614-6.25 9.668-6.25s8.985 4.912 9.668 6.25c-.683 1.338-3.614 6.25-9.668 6.25"
      clipRule="evenodd"
    />
  </>
);

const Showing = Icon('showing', svgContents);

export default Showing;
